import $ from 'jquery';
import { initFilterNavigation } from './filters';
import initListing from './listing';
import moment from 'moment-timezone';
import WithState from '../../WithState';

class JobsContent extends WithState {
	state = {
		loading: false,
	};

	constructor(context) {
		super();

		this.context = context;
		this.$context = $(this.context);

		this.$filterLocations = this.$context.find(
			`[data-option-group="locations"]`
		);
		this.$filterDepartments = this.$context.find(
			`[data-option-group="departments"]`
		);

		this.endpoint = this.$context.data('endpoint');

		this.$listingInfo = this.$context.find(`.listing__info`);
		this.$listingContent = this.$context.find(`.listing__content`);
		this.$empty = this.$context.find(`.listing__empty`);
		this.$footer = this.$context.find(`.listing__footer`);
	}

	init() {
		this.initializeContentObserver();
		this.initializeContent();
	}

	initializeContent() {
		this.setState({ loading: true });

		$.getJSON(this.endpoint, (response) => {
			this.setState({ loading: false });

			const data = response.data;

			this.populateListingInfo(this.$listingInfo, data?.total_jobs);

			this.populateFilterItems(this.$filterLocations, data.locations);
			this.populateFilterItems(this.$filterDepartments, data.departments);
			initFilterNavigation(this.context);

			this.populateJobItems(this.$listingContent, data?.jobs);
			initListing(this.context);
			this.onListingUpdate();
		});
	}

	initializeContentObserver() {
		if (this.$listingContent.length) {
			const observer = new window.MutationObserver(
				this.onListingUpdate.bind(this)
			);

			observer.observe(this.$listingContent.get(0), {
				subtree: true,
				attributes: true,
			});
		}
	}

	onListingUpdate() {
		// Get current items shown in the list
		const shownItems = this.$listingContent.find('.listing__item.show');
		// Update listing info
		this.populateListingInfo(this.$listingInfo, shownItems?.length);

		// Update elements visibility
		this.$listingContent.toggleClass('hidden', shownItems?.length === 0);
		this.$empty.toggleClass('hidden', shownItems?.length !== 0);
		this.$footer.toggleClass('hidden', shownItems?.length === 0);
	}

	populateListingInfo($container, total = 0) {
		const text = total !== 1 ? 'jobs' : 'job';
		$container.html(`Currently viewing <span>${total} ${text}</span>`);
	}

	populateFilterItems($container, items) {
		items.forEach((item) => {
			$container.append(`
				<li class="filter__navigation__item"
					data-option-value="${this.sanitizeOptionValue(item)}"
					role="menuitemcheckbox"
					aria-checked="false">
					${item}
				</li>
			`);
		});
	}

	populateJobItems($container, items = []) {
		items.forEach((item) => {
			$container.append(this.generateJobItemMarkup(item));
		});
	}

	generateJobItemMarkup(item) {
		const departments = item.department ? [item.department] : [];
		const locations = item.location ? [item.location] : [];
		const [department, location] = this.generateJobItemClasses(
			departments,
			locations
		);

		return `
			<div
				class="listing__item show"
				data-departments="${department || ''}"
				data-locations="${location || ''}"
				>
				<div class="listing__item-inner">
					${this.generateEyebrowMarkup(departments, locations)}
					${this.generateTitleMarkup(item)}
					<time class="listing__item__date">
						${this.getDateAgo(item.createdAt)}
					</time>
				</div>
				${
					(item?.hostedUrl &&
						`<div class="listing__item__cta">
							<a href="${item.hostedUrl}"
							target="_blank">Apply Now</a>
						</div>`) ||
					''
				}
			</div>
		`;
	}

	getDepartments(units = []) {
		const departments = [];
		units.forEach((unit) => {
			if ('Department' !== unit.typeCode.codeValue) {
				return;
			}
			const shortName = unit.nameCode
				? unit.nameCode.shortName
				: undefined;
			const longName = unit.nameCode ? unit.nameCode.longName : undefined;
			const department = shortName ?? longName;
			if (department) {
				departments.push(department);
			}
		});
		return departments;
	}

	getLocations(requisitionLocations = []) {
		const locations = [];
		requisitionLocations.forEach((requisitionLocation) => {
			const shortName = requisitionLocation.nameCode
				? requisitionLocation.nameCode.shortName
				: undefined;
			const longName = requisitionLocation.nameCode
				? requisitionLocation.nameCode.longName
				: undefined;
			const address = requisitionLocation.address.countryCode;
			const location = shortName ?? longName ?? address;
			if (location) {
				locations.push(location);
			}
		});
		return locations;
	}

	generateJobItemClasses(departments = [], locations = []) {
		return [
			this.sanitizeOptionValue(departments?.length ? departments[0] : ''),
			this.sanitizeOptionValue(locations?.length ? locations[0] : ''),
		];
	}

	generateEyebrowMarkup(departments, locations) {
		let markup = `<p class="listing__item__eyebrow">`;
		[...departments, ...locations].forEach((item) => {
			markup += `<span>${item}</span>`;
		});
		markup += `</p>`;
		return markup;
	}

	generateTitleMarkup(item) {
		const workTypeMarkup = item.commitment
			? `<span>(${item.commitment})</span>`
			: '';
		return `<h3 class="listing__item__title">
					${item.title}
					${workTypeMarkup}
				</h3>
		`;
	}

	sanitizeOptionValue(string) {
		return string.replaceAll(',', '').replaceAll(' ', '-').toLowerCase();
	}

	getDateAgo(value) {
		const date = moment(value).format('YYYY-MM-DD'),
			timezone = window.scriptVars.wp_timezone,
			now = moment().tz(timezone).format('YYYY-MM-DD'),
			days = moment(now).diff(date, 'days');

		let ago = `just now`;

		if (days > 30) {
			ago = `30+ days ago`;
		} else if (days > 1) {
			ago = `${days} ${days === 1 ? ' day' : ' days'} ago`;
		}

		return ago;
	}

	componentDidUpdate() {
		this.$context.toggleClass('loading', this.state.loading);
	}
}

export default function initContent(context) {
	Array.from(document.querySelectorAll(context)).forEach((element) => {
		const content = new JobsContent(element);
		content.init();
	});
}
